<input hidden="" (change)="handleInputChange($event)" id="attachment_files" type="file" accept=".html">
    <label for="attachment_files" class="w-100">
        <div appDnd (filesChangeEmitter)="onFilesChange($event)" (filesInvalidEmitter)="onFileInvalids($event)" class="drop-box" tabindex="0">
        <div class="overlay"></div>
        <span><div class="preview"><p>{{placeholderText ? placeholderText : ('common.selectAnImage' | translate) }}</p></div></span>
        </div>
    </label>
    <label for="attachment_files">
      <fa-icon [icon]="faFile"></fa-icon> <span class="ms-1">{{fileName}}</span>
    </label>

